var m = require('mithril');
var modalForm = require('../../layout/components/modalForm');
var datasetForm = modalForm(require('../../data/models/dataset'));
var heading = require('../../components/heading');
var Model = require('../../libs/Model');
var dragscroll = require('../../libs/dragscroll');
var columnForm = require('../../data/components/columnModal');
var extendedPropsNumberForm = modalForm(require('../../dashboards/models/extendedPropsNumber'));
var extendedPropsStringForm = modalForm(require('../../dashboards/models/extendedPropsString'));
var addElementModal = require('../components/addElementModal');
var button = require('../../components/button');
var reportEventPanel = require('./reportEventPanel');
var eventBindings = require('../../../../../models/reports/eventBindings');

var Report = Object.assign(require('../../../../../models/reports/report'), Model);


var component = {};

component.oninit = function (vnode) {
  var ctrl = this;
  ctrl.reportRecord = vnode.attrs.record();
};

component.view = function  atsReportBuildView(vnode) {
  var ctrl = this;
  ctrl.reportRecord = vnode.attrs.record();
  var record = ctrl.reportRecord;
  var reportEdges = eventBindings.getReportContentContainsEdges(record);
  var elementEdge = reportEdges.find(function (edge) {
    return edge && edge.in && Array.isArray(edge.in.columns);
  });
  var element = elementEdge && elementEdge.in;
  var datasets = element && Array.isArray(element.out_Contains) ? element.out_Contains : reportEdges;
  var useElementColumns = element && Array.isArray(element.columns) && element.columns.length;
  var columns = useElementColumns
    ? element.columns
    : (datasets[0] && datasets[0].in && Array.isArray(datasets[0].in.out_Column) ? datasets[0].in.out_Column : []);
  var datasetParentRid = element && element['@rid'] ? element['@rid'] : (record && record['@rid']);

  if (!columns.length) {
    return m('div', [
      m(heading, {label: 'OR Suites', class: 'f1 mh3 pv2'}),
      m('div.mh3', 'No OR compliance columns found for this report.')
    ]);
  }

  return m('div', [
    m(reportEventPanel, {record: record, showLocation: false}),
    m(heading, {label: 'OR Suites', class: 'f1 mh3 pv2'}),
    m('div.overflow-hidden.mb3.mh3', [
      m('div.dragscroll-container', [
        m('div.dragscroll', {oncreate: dragscroll}, [
          m('table.w-100.f3.fw2.pt2.pb3.pr4.narrow', {style: {tableLayout: 'fixed'}}, [
            m('colgroup',  [
              m('col', {span:1, style:{width: '6em'}}),
              columns.map(function (col) {
                return m('col', {span:1, style:{width: '8em'}})
              }),
              m('col', {span:1, style:{width: '6em'}}),
            ]),
            m('tr', [
              m('th.br.bb-0.bt-0.bl-0.b--dotted.bw1.fw2'),
              columns.map(function (column, idx) {
                var columnName = column.name || column;
                return m('th.br.bb-0.bt-0.bl-0.b--dotted.bw1.fw2', {index: idx}, [
                  m('div', [
                    m('p.ma0.tc', columnName)
                  ])
                ])
              }),
            ]),
            m('tbody', [
              datasets.map( containsEdge => {
                var dataset = containsEdge.in || [];
                if (typeof dataset.extendedProps === 'undefined') {
                  dataset.extendedProps = {};
                }
                return m('tr', [
                  m('td.br.bb-0.bl-0.b--dotted.bw1.w-25', [
                    m('div.tc', [
                      m('p.ma0', dataset.name),
                      m('div', [
                        m('i.blue.ion-ios-compose.blue.dib.v-mid.mh2', {onclick: datasetForm.editDialogue.bind(datasetForm, dataset)}),
                        m('i.ion-ios-trash.dib.v-mid.mh2.red', {onclick: datasetForm.deleteDialogue.bind(datasetForm, dataset)})
                      ])
                    ])
                  ]),
                  useElementColumns ? columns.map(function (col, idx) {

                    var columnRecord;
                    var tdForm;

                    if (col.type && col.type !== 'point') {
                      if (col.type && col.type === 'number') {
                        tdForm = extendedPropsNumberForm;
                      } else if (col.type && col.type === 'string') {
                        tdForm = extendedPropsStringForm;
                      }

                      return m('td.br.bb-0.bl-0.b--dotted.bw1', [
                        m('div.tc', 
                          {
                            onclick: tdForm.editDialogue.bind(tdForm, dataset, {property: col.id})
                          }, 
                          [
                            m('div.br2.pv1.blue.flex.justify-center.tc.f2', [
                              m('span.mr2', dataset.extendedProps && dataset.extendedProps[col.id] !== undefined
                                ? dataset.extendedProps[col.id]
                                : m('i.blue.ion-ios-compose'))
                            ])
                          ]
                        )  //a
                      ]); // td

                    } else {

                      if (!Array.isArray(dataset.out_Column)) {
                        columnRecord = undefined;
                      } else {
                        columnRecord = dataset.out_Column.find(function (e) { return e.index === col.id });
                      }
                      if (typeof columnRecord === 'undefined') {
                        return m('td.br.bb-0.bl-0.b--dotted.bw1.ph2.pv2', [
                          m('div.tc', 
                            {
                              onclick: columnForm.editDialogue.bind(columnForm, {out: dataset['@rid'], index: col.id}, {columnName: col.name})
                            }, 
                            [
                              m('i.ion-plus.blue')
                            ]
                          )  //a
                        ]) // td
                      } else {
                        columnRecord.key = columnRecord['@rid']
                        return m('td.tc.bb-0.br.bl-0.b--dotted.bw1.ph2.pv2', [
                          m('div.br2.ph2.pv1.bg-blue.flex.justify-between.', {onclick: columnForm.editDialogue.bind(columnForm, columnRecord)}, [
                            m('p.ma0.dark-gray.ph2.truncate.f4', {style: {maxWidth: '8em'}}, columnRecord.in.name),
                            m('i.icon.ion-ios-compose.dark-gray.ph3', {
                              onclick: columnForm.deleteDialogue.bind(columnForm, columnRecord),
                            })
                          ])
                        ])
                      }
                    }
                  }) : (Array.isArray(dataset.out_Column) ? dataset.out_Column : []).map(function (col, idx) {

                    var columnRecord;
                    var tdForm;

                    if (col.type && col.type !== 'point') {
                      if (col.type && col.type === 'number') {
                        tdForm = extendedPropsNumberForm;
                      } else if (col.type && col.type === 'string') {
                        tdForm = extendedPropsStringForm;
                      }

                        return m('td.br.bb-0.bl-0.b--dotted.bw1', [
                          m('div.tc', 
                            {
                              onclick: tdForm.editDialogue.bind(tdForm, dataset, {property: col.id})
                            }, 
                            [
                              m('div.br2.pv1.blue.flex.justify-center.tc.f2', [
                                m('span.mr2', dataset.extendedProps && dataset.extendedProps[col.id] !== undefined
                                  ? dataset.extendedProps[col.id]
                                  : m('i.blue.ion-ios-compose'))
                              ])
                            ]
                          )  //a
                      ]); // td

                    } else {

                      if (!Array.isArray(dataset.out_Column)) {
                        columnRecord = undefined;
                      } else {
                        columnRecord = dataset.out_Column.find(function (e) { return e.index === col.index });
                      }
                      if (typeof columnRecord === 'undefined') {
                        return m('td.br.bb-0.bl-0.b--dotted.bw1.ph2.pv2', [
                          m('div.tc', 
                            {
                              onclick: columnForm.editDialogue.bind(columnForm, {out: dataset['@rid'], index: col.id}, {columnName: col.name})
                            }, 
                            [
                              m('i.ion-plus.blue')
                            ]
                          )  //a
                        ]) // td
                      } else {
                        columnRecord.key = columnRecord['@rid']
                        return m('td.tc.bb-0.br.bl-0.b--dotted.bw1.ph2.pv2', [
                          m('div.br2.ph2.pv1.bg-blue.flex.justify-between.', {onclick: columnForm.editDialogue.bind(columnForm, columnRecord)}, [
                            m('p.ma0.dark-gray.ph2.truncate.f4', {style: {maxWidth: '8em'}}, columnRecord.in.name),
                            m('i.icon.ion-ios-compose.dark-gray.ph3', {
                              onclick: columnForm.deleteDialogue.bind(columnForm, columnRecord),
                            })
                          ])
                        ])
                      }
                    }
                  })
                ])
              }),
              m('tr', [
                m('td.br.bb-0.bl-0.b--dotted.bw1.pa3', [
                  m('div.flex.justify-center', [
                    m(button, {
                      class: 'w3',
                      label: m('i.f4.ion-plus.blue'),
                      func: datasetForm.editDialogue.bind(datasetForm, {parent: datasetParentRid})
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    m('div.flex.justify-between', [
      m(button, {label: 'Add Sheet from Dashboards', class: 'w-40 mh3', func: 
        addElementModal.editDialogue.bind(addElementModal, record)})
    ])
  ])
};

module.exports = component;
